import React from 'react'
import Login from './Login'
import Apply from './Apply'

const LoginPage = () => {
  return (
    <div className='LoginPage'>
      {/*  <Apply/> */}
      <Login/>

      <div className='LoginExplanation'>
    <h1>Welcome to MathTounsi</h1>
    <p>MathTounsi is a non-profit initiative dedicated to empowering Tunisian math Olympiad enthusiasts — from passionate high school students to curious problem solvers — with high-quality resources, community support, and competition opportunities.</p>
    <h2>🏆 Why It Matters</h2>
    <p>Opportunities for Olympiad preparation are often limited or centralized. MathTounsi bridges that gap by creating an accessible, inclusive, and student-driven platform where anyone — regardless of location or background — can thrive and aim for national and international success.</p>

    <h3>MathTounsi is by students, for students — proudly Tunisian, fully educational, and deeply passionate about mathematics.</h3>

    <p>To create an account you have to submit an application to get inrolled into the program .</p>
      </div>
    </div>
  )
}

export default LoginPage
